// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const RequestIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="RequestIcon" ref={forwardedRef} {...props}>
      <path d="m9.75 5.25 2.828 2.828 1.06-1.059L12.617 6h2.132v6.104a2.745 2.745 0 0 0-2 2.646 2.75 2.75 0 0 0 1.031 2.147 2.75 2.75 0 1 0 2.469-4.793V5.5a1 1 0 0 0-1-1h-2.626l1.017-1.016-1.063-1.062zm5.75 8.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5" />
      <path d="M8.25 5.5a2.75 2.75 0 1 0-3.5 2.646v3.958a2.745 2.745 0 0 0-2 2.646A2.745 2.745 0 0 0 5.5 17.5a2.75 2.75 0 0 0 .75-5.396V8.146a2.75 2.75 0 0 0 2-2.646M5.5 4.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m1.25 10.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const RequestIcon = /* @__PURE__ */ Object.assign(RequestIconComponent, {
  displayName: 'RequestIcon',
});
